import { render, staticRenderFns } from "./privateequityjapanJP.vue?vue&type=template&id=a14c6066"
import script from "./privateequityjapanJP.vue?vue&type=script&lang=js"
export * from "./privateequityjapanJP.vue?vue&type=script&lang=js"
import style0 from "./privateequityjapanJP.vue?vue&type=style&index=0&id=a14c6066&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports